<h2 mat-dialog-title>როლის დამატება</h2>

<form [formGroup]="form" (ngSubmit)="create()">
    <mat-dialog-content>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>სახელწოდება</mat-label>
            <input matInput formControlName="name" />
            @if (form.controls.name.touched && form.controls.name.invalid) {
                <mat-error>სავალდებულო ველი</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>აღწერა</mat-label>
            <input matInput formControlName="description" />
            @if (form.controls.description.touched && form.controls.description.invalid) {
                <mat-error>სავალდებულო ველი</mat-error>
            }
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="close()">გაუქმება</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
            დადასტურება
        </button>
    </mat-dialog-actions>
</form>
